import { s as script } from './Image-abc397f0.js';
export { s as BImage } from './Image-abc397f0.js';
import { u as use, a as registerComponent } from './plugins-9a909142.js';
import './config-86592f14.js';
import './helpers-8130329a.js';
import './typeof-92b42de1.js';
import 'vue';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
  }
};
use(Plugin);

export { Plugin as default };
